<template>
  <div class="ac-cropper-container">
    <div class="ac-cropper-header">
      Use the slider to adjust the logo size on the member's home screen
    </div>
    <cropper
      ref="cropper"
      class="cropper"
      background-class="cropper__background"
      foreground-class="cropper__foreground"
      image-restriction="stencil"
      :src="cropperPreview"
      :stencil-size="stencilSize"
      :stencil-props="{
        lines: {},
        handlers: {},
        movable: false,
        scalable: false,
        aspectRatio: 1,
        previewClass: 'cropper__stencil',
      }"
      :min-width="150"
      :min-height="150"
      :debounce="false"
      :transitions="false"
      :default-size="defaultSize"
      :move-image="false"
      @change="onChange"
    />
    <CropperZoomer
      :zoom="zoom"
      @change="onZoom"
    />
  </div>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper';

import CropperZoomer from '@shared/components/partnerSettings/branding/CropperZoomer.vue';

export default {
  name: 'LogoCropper',
  components: {
    Cropper,
    CropperZoomer,
  },
  props: {
    cropperPreview: String,
    primaryColor: String,
    onCropperChange: Function,
  },
  data() {
    return {
      zoom: 0,
    };
  },
  mounted() {
    const [background] = document.getElementsByClassName('cropper__background');
    background.style.backgroundColor = this.primaryColor;
  },
  methods: {
    defaultSize({ imageSize }) {
      return {
        width: Math.min(imageSize.height, imageSize.width),
        height: Math.min(imageSize.height, imageSize.width),
      };
    },
    stencilSize({ boundaries }) {
      return {
        width: Math.min(boundaries.height, boundaries.width) - 48,
        height: Math.min(boundaries.height, boundaries.width) - 144,
      };
    },
    onChange(result) {
      const {
        cropper,
      } = this.$refs;
      if (cropper) {
        const {
          coordinates: {
            width,
            height,
          },
          imageSize: {
            width: imageWidth,
            height: imageHeight,
          },
          sizeRestrictions: {
            minWidth,
            minHeight,
          },
        } = cropper;
        if (imageWidth / imageHeight > width / height) {
          this.zoom = (imageHeight - height) / (imageHeight - minHeight);
        } else {
          this.zoom = (imageWidth - cropper.coordinates.width) / (imageWidth - minWidth);
        }
      }
      this.onCropperChange(result);
    },
    onZoom(value) {
      const {
        cropper,
      } = this.$refs;
      if (cropper) {
        const {
          imageSize: {
            width,
            height,
          },
          sizeRestrictions: {
            minWidth,
            minHeight,
          },
        } = cropper;
        if (height < width) {
          cropper.zoom(
            (height - this.zoom * (height - minHeight))
              / (height - value * (height - minHeight)),
          );
        } else {
          cropper.zoom(
            (width - this.zoom * (width - minWidth))
              / (width - value * (width - minWidth)),
          );
        }
      }
    },
  },
};
</script>

<style lang="scss">

.ac-cropper-container {
  margin-bottom: 50px;
  width: 400px;
  .ac-cropper-header {
    background-color: $SUNSET100;
    font-size: 0.6875rem;
    font-weight: 700;
    text-align: center;
    padding: 8px 0;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  .cropper {
    width: 100%;
    height: 304px;
    &__foreground {
      background-color: #edf2f4;
    }
    &__stencil {
      border: solid 5px rgb(29, 161, 242);
    }
  }
}
</style>
